import { render, staticRenderFns } from "./editActivityPriceModel.vue?vue&type=template&id=f81a28ac&scoped=true&"
import script from "./editActivityPriceModel.vue?vue&type=script&lang=js&"
export * from "./editActivityPriceModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81a28ac",
  null
  
)

export default component.exports